// Coach-facing names come from saved artwork identity, never a job title,
// generation ID, current calendar year or caller-supplied email filename.
const extensions = {'image/png':['png'],'image/jpeg':['jpg','jpeg'],'image/webp':['webp'],'application/pdf':['pdf'],'application/zip':['zip']}
const proofRoles = new Set(['sheet','top','left','right','palm','exploded','marketing','technical_sheet','artwork_engine_output'])
// eslint-disable-next-line no-control-regex
const clean = value => String(value ?? '').normalize('NFKC').replace(/[\u0000-\u001f\u007f\u202a-\u202e\u2066-\u2069]/g,' ').replace(/[\\/:*?"<>|]/g,'-').replace(/\s+/g,' ').trim().replace(/^[. ]+|[. ]+$/g,'')
const bounded = (value, limit) => { let out=''; for(const char of value){if(new TextEncoder().encode(out+char).length>limit)break;out+=char}return out.trim() }

export function artworkIdentity(job, asset={}) {
  if(asset.artworkIdentity)return Object.fromEntries(['schoolName','sport','year'].map(key=>[key,clean(asset.artworkIdentity[key])]))
  let spec=job?.spec || {}
  if(asset.role==='artwork_engine_output') {
    const engine=job?.artworkEngine
    const revision=asset.engineRevision
    const saved=revision==null||revision===engine?.revision?engine:engine?.history?.find(row=>row.revision===revision)
    if(!saved)return {schoolName:'',sport:'',year:''}
    spec={...spec,...saved.spec}
  } else if(asset.revision!=null&&asset.revision!==job?.artworkRevision) {
    return {schoolName:'',sport:'',year:''}
  }
  return {schoolName:clean(spec.schoolName),sport:clean(spec.sport),year:clean(spec.year)}
}

export function customerArtworkFilename(job, asset={}) {
  const identity=artworkIdentity(job,asset), allowed=extensions[asset.type]
  if(!allowed||!identity.schoolName||!identity.sport||!/^\d{4}(?:-\d{2,4})?$/.test(identity.year))return ''
  const original=String(asset.originalName||asset.name||'').match(/\.([a-z]+)$/i)?.[1]?.toLowerCase()
  const extension=allowed.includes(original)?original:allowed[0]
  return `Southern Recognition, Inc. - (${bounded(clean(identity.schoolName),100)} - ${bounded(clean(identity.sport),65)} - ${identity.year}).${extension}`
}

export function artworkDownloadName(job, asset) {
  return (proofRoles.has(asset.role)&&customerArtworkFilename(job,asset)) || asset.name
}

export function nameSavedArtwork(job, asset) {
  const name=proofRoles.has(asset.role)&&customerArtworkFilename(job,asset)
  return name?{...asset,name,originalName:asset.originalName||asset.name,artworkIdentity:artworkIdentity(job,asset)}:asset
}

// RFC 2231 preserves Unicode without putting raw UTF-8 or header controls into
// MIME. Each parameter stays below the RFC 5322 hard line limit.
export function mimeFilenameParameter(parameter,name) {
  const fallback=name.replace(/[^\x20-\x7e]/g,'_').replace(/["\\]/g,'_')
  if(fallback===name)return `${parameter}="${name}"`
  const encoded=encodeURIComponent(name).replace(/[!'()*]/g,char=>'%'+char.charCodeAt(0).toString(16).toUpperCase())
  return `${parameter}="${fallback}";\r\n ${parameter}*=UTF-8''${encoded}`
}
